// Generated by i18nline and preact-i18nline.
import I18n from 'preact-i18nline/i18n';

I18n.supportedLocales = ['ee','en','fi'];
I18n.defaultLocale = 'en';

I18n.import = locale => {
	// we use a switch here so the import statements are statically
	// analyzable. the use of import() will make build tools generate
	// separate bundles which are downloaded on-demand.
	switch (locale) {
		case 'ee': return import(/* webpackChunkName: 'i18n.ee' */ './ee.json');
		case 'en': return import(/* webpackChunkName: 'i18n.en' */ './en.json');
		case 'fi': return import(/* webpackChunkName: 'i18n.fi' */ './fi.json');
		default: return import(/* webpackChunkName: 'i18n.default' */ './default.json');
	}
};

if ((typeof module === 'object') && module.hot) {
	module.hot.accept('./ee.json', I18n.reload('ee'));
	module.hot.accept('./en.json', I18n.reload('en'));
	module.hot.accept('./fi.json', I18n.reload('fi'));
	module.hot.accept('./default.json', I18n.reload('default'));
}

export default I18n;



// WEBPACK FOOTER //
// ./i18n/index.js